import React, { useContext, useEffect, useState } from 'react';
import { Switch, Route, Redirect, useLocation, useHistory } from 'react-router-dom';
import { delayImport } from 'utils';

import './index.scss';
import { Breadcrum, Header } from 'components';
import { AuthContext, HomeContext, ModalContext } from 'contexts';
import {
    ACTIVE_SHIPMENTS_URL,
    ACTIVE_SHIPMENT_DETAILS_URL,
    ALL_ISSUES_URL,
    ARCHIVE_DETAILS_URL,
    ARCHIVE_URL,
    BOOKING_REQUEST_URL,
    NOT_FOUND_URL,
    ORGANIZATIONS_DETAILS_URL,
    ORGANIZATIONS_LIST_URL,
    ORGANIZATIONS_URL,
    OTHER_TEMPLATES_URL,
    PERSONAL_SETTINGS_URL,
    TEAMS_URL,
    TEAM_DETAILS_URL,
    TEMPLATES_URL,
    TRACK_SHIPMENT_URL,
    VESSEL_SCHEDULE_RESULTS_URL,
    VESSEL_SCHEDULE_URL,
    SHIPMENT_DETAILS,
    SHIPMENT_DETAILS_TEMPLATE,
    ADD_NEW_REQUEST_URL,
    VIEW_DOCUMENTS_URL,
    EDIT_REQUEST_URL,
    VESSEL_SCHEDULE_BASE_URL,
    ORGANIZATIONS_INFO_URL, PATH_NAME_AFTER_LOGIN,
} from 'actions';
import { userInfo } from 'os';

const TrackShipment = delayImport(import('pages/Home/TrackShipment'));
const VesselSchedule = delayImport(import('pages/Home/VesselSchedule'));
const VesselScheduleResult = delayImport(import('pages/Home/VesselScheduleResult'))
const ActiveShipments = delayImport(import('pages/Home/ActiveShipments'));
const ActiveShipmentsDetails = delayImport(import('pages/Home/ActiveShipmentsDetails'));
const Archive = delayImport(import('pages/Home/Archive'));
const ArchiveShipmentsDetails = delayImport(import('pages/Home/ArchiveShipmentsDetails'));
const BookingRequest = delayImport(import('pages/Home/BookingRequest'));
const AllIssues = delayImport(import('pages/Home/AllIssues'));
const AddNewRequest = delayImport(import('pages/Home/AddNewRequest'));
const ShipmentDetails = delayImport(import('pages/Home/ShipmentDetails'));
const ViewDocuments = delayImport(import('pages/Home/ViewDocuments'));

const PersonalSetting = delayImport(import('pages/UsersManagement/PersonalSetting'));

const Organizations = delayImport(import('pages/Organizations/Organizations'));
const OrganizationDetails = delayImport(import('pages/Organizations/OrganizationDetails'));
const OrganizationInfo = delayImport(import('pages/Organizations/OrganizationInfo'));
const TeamDetails = delayImport(import('pages/Organizations/TeamDetails'));
const Templates = delayImport(import('pages/Organizations/Templates'));

const HomeLayout = () => {
    const location = useLocation();
    const history = useHistory();

    const { setIsArchive } = useContext(HomeContext);
    const { doGetUserInfo } = useContext(AuthContext);
    const { hideAllModals } = useContext(ModalContext);
    const [isBreadcrum, setIsBreadcrum] = useState(false);

    /*eslint-disable */

   useEffect(() => {
      return history.listen((location) => {
        hideAllModals();
      })
   },[history])


    useEffect(() => {
        setIsArchive(location && location.pathname.indexOf('archive') > -1);
        setIsBreadcrum(checkBreadcrumAvailable());
        const locationEmail = (callback) => {
            if (localStorage.getItem(PATH_NAME_AFTER_LOGIN)){
                history.push(localStorage.getItem(PATH_NAME_AFTER_LOGIN));
                if (callback) callback();
            }
        }
        locationEmail(() => {
            localStorage.removeItem(PATH_NAME_AFTER_LOGIN)
        })
    }, [location]);

    useEffect(() => {
        if (!userInfo) doGetUserInfo(null, location.pathname.indexOf(`${VESSEL_SCHEDULE_BASE_URL}/`) < 0 && location.pathname.indexOf(BOOKING_REQUEST_URL) < 0);
    }, [userInfo])
    /*eslint-enable */

    const checkBreadcrumAvailable = () => {
        const exceptions = [
            VESSEL_SCHEDULE_BASE_URL,
            ACTIVE_SHIPMENTS_URL,
            ARCHIVE_URL,
            ORGANIZATIONS_LIST_URL,
            TEAMS_URL,
            TEMPLATES_URL,
            OTHER_TEMPLATES_URL,
            BOOKING_REQUEST_URL,
            SHIPMENT_DETAILS,
            ORGANIZATIONS_INFO_URL.replace('/:orgId', "")
        ];
        return exceptions.some(e => location.pathname.indexOf(`${e.slice(1, e.length)}/`) > -1 || location.pathname === SHIPMENT_DETAILS);
    }

    return (
        <div className={`tr__home-layout ${isBreadcrum ? 'having-breadcrum' : ''}`}>
            <Header />
            {isBreadcrum && (
                <Breadcrum />
            )}
            <div className="col-12">
                <Switch>
                    {/* Organization Routes */}
                    <Route path={ORGANIZATIONS_URL} exact>
                        <Redirect to={ORGANIZATIONS_LIST_URL} />
                    </Route>
                    <Route path={ORGANIZATIONS_LIST_URL} exact component={Organizations} />
                    <Route path={ORGANIZATIONS_DETAILS_URL} exact component={OrganizationDetails} />
                    <Route path={ORGANIZATIONS_INFO_URL} exact component={OrganizationInfo} />
                    <Route path={TEAMS_URL} exact component={Organizations} />
                    <Route path={TEAM_DETAILS_URL} exact component={TeamDetails} />
                    <Route path={TEMPLATES_URL} component={Templates} />
                    <Route path={OTHER_TEMPLATES_URL} component={Templates} />

                    {/* Personal Setting Routes */}
                    <Route path={PERSONAL_SETTINGS_URL} exact component={PersonalSetting} />

                    {/* Home Routes */}
                    <Route path="/" exact>
                        <Redirect to={TRACK_SHIPMENT_URL} />
                    </Route>
                    <Route path={TRACK_SHIPMENT_URL} exact component={TrackShipment} />
                    <Route path={VESSEL_SCHEDULE_URL} exact component={VesselSchedule} />
                    <Route path={VESSEL_SCHEDULE_RESULTS_URL} exact component={VesselScheduleResult} />
                    <Route path={ACTIVE_SHIPMENT_DETAILS_URL}  component={ActiveShipmentsDetails} />
                    <Route path={ACTIVE_SHIPMENTS_URL} exact component={ActiveShipments} />
                    <Route path={ARCHIVE_URL} exact component={Archive} />
                    <Route path={ARCHIVE_DETAILS_URL}  component={ArchiveShipmentsDetails} />
                    <Route path={BOOKING_REQUEST_URL} exact component={BookingRequest} />
                    <Route path={ALL_ISSUES_URL} exact component={AllIssues} />
                    <Route path={ADD_NEW_REQUEST_URL} exact component={AddNewRequest} />
                    <Route path={VIEW_DOCUMENTS_URL} exact component={ViewDocuments} />
                    <Route path={EDIT_REQUEST_URL} exact component={AddNewRequest} />
                    <Route path={SHIPMENT_DETAILS} exact component={ShipmentDetails} />
                    <Route path={SHIPMENT_DETAILS_TEMPLATE} exact component={ShipmentDetails} />
                    <Route path="*">
                        <Redirect to={NOT_FOUND_URL} />
                    </Route>
                </Switch>
            </div>
        </div>
    )
};

export default HomeLayout;
